<div class="col-sm-12 detail" *ngIf="!isEmpty" style="height: 100%" (click)="common.outSide($event)">
    <div class="header col-sm-12">
      <div class="col-sm-8">
        <h2 *ngIf="!isHisto"> Liste des trop perçus </h2>
        <h2 *ngIf="isHisto"> Historique des trop perçus </h2>
        <div class="text-underline historique" style="padding-right: 0px" (click)="showHisto()">
           <span *ngIf="!isHisto"> Afficher l'historique </span>
           <span *ngIf="isHisto"> Afficher la liste </span>
        </div>
      </div>
      <div class="col-sm-4 text-right">
        <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
        <button class="btn-header uppercase actionPricipal" id="valide" (click)="valide()"> Valider </button>
        <!--div>
          <label class="text-left uppercase text-underline historique" (click)="common.getLogs(detail.id, '43', modalService);"> Voir l'historique </label>
          <label class="text-left uppercase text-underline historique">Voir les documents</label>
        </div-->
      </div>
    </div>
  
    <div class="col-sm-12 ligneBon liste">
        <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listTropPercus || []" [columnMode]="'force'" [headerHeight]="35"
        [footerHeight]="0" [rowHeight]="30"  [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
        [loadingIndicator]="loadingIndicator" >
        
        <ngx-datatable-column prop="date">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase"> Date </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
               <span *ngIf="isHisto"> {{value}} </span>
                <input *ngIf="!isHisto" type="text" class="input detailfact" id="date{{rowIndex}}" placeholder="Date" [(ngModel)]="row.date"
                    autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')" (ngModelChange)="common.changeDateFormat('date', row); change(row)">
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="montant">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase"> Montant </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <span *ngIf="isHisto"> {{value}} </span>
                <input *ngIf="!isHisto" type="text" class="input detailfact text-right" id="montant{{rowIndex}}" placeholder="Montant" [(ngModel)]="row.montant"
                    autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')"  (ngModelChange)="change(row)">
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column  prop="libelle">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader">
                    <span class="uppercase"> Description </span>
                </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <span *ngIf="isHisto"> {{value}} </span>
                <input *ngIf="!isHisto" type="text" class="input detailfact" id="description{{rowIndex}}" placeholder="Description" [(ngModel)]="row.libelle"
                    autocomplete="off" (keydown.enter)="common.focusNext('.ligneBon')"  (ngModelChange)="change(row)">
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="100" [sortable]="false" [canAutoResize]="false"
            [draggable]="false" [resizeable]="false">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                <div class="text-underline historique" style="padding-right: 0px" [ngClass]="{'disabledbutton': !row.id}" (click)="selectedRow = row; common.openModal(modalService, articleTmp)">
                    Rembourser
                 </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false"
            [draggable]="false" [resizeable]="false" *ngIf="!isHisto">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                <div class="text-center"><button class="btn-detail" (click)="selectedRow = row; common.openModal(modalService, confirme)">
                    <i class="fa fa-trash"></i>
                </button></div>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
    </div>
    <div class="addLigne col-sm-12 uppercase">
      <div class="col-sm-7 text-left" *ngIf="!isHisto">
        <button class="btn-add" id="addLigne" (click)="addLigne()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addLigne()">Ajouter une ligne</span>
        
      </div>
      <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
  </div>
  
  <app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>
  
  <ng-template #confirme>
      <div class="modal-header">
          <h4 class="modal-title pull-left"> Confirmation </h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body" style="height: auto">
          <div>
              <div class="col-sm-12">
                  <label class="cofirmemsg"> Êtes-vous sûr de vouloir effacer ce trop perçu ? </label>
              </div>
          </div>
          <div class="text-right" style="margin-top: 15px;">
              <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();deleteLigne(selectedRow)"> OUI </button>
              <button type="button" class=" btn-close" (click)="common.closeModal()"> NON </button>
          </div>
      </div>
  </ng-template>

  <ng-template #articleTmp>
      <div class="modal-header">
          <h4 class="modal-title pull-left"> Article remboursement trop perçu </h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body" style="height: auto">
          <div>
              <app-autocomplete [placeholder]="'Article remboursement'" (searchfunction)="searchArticle($event)"
                  (selectfunction)="article = $event" [results]="dataArticle" [defaultsearch]="article ? article.libelleObjetEntite : ''"
                  [minlength]="1"></app-autocomplete>
          </div>
          <div class="text-right" style="margin-top: 15px;">
              <button type="button" class=" btn-close btn-valider" (click)="rembourser(selectedRow);">
                  Valider </button>
              <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler </button>
          </div>
      </div>
  </ng-template>

  <ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer</button>
    </div>
  </div>
</ng-template>